import "./lib/storage-migration";
import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import { AppErrorBoundary } from "./components/AppErrorBoundary";
import { reloadForNewBuild } from "./lib/chunk-reload";

// Vite reports a failed chunk preload here; reload once for the current build instead of throwing.
window.addEventListener("vite:preloadError", event => { if (reloadForNewBuild()) event.preventDefault(); });

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </React.StrictMode>,
);
